import React from 'react'
import PropTypes from 'prop-types'

const Avatar = (props) => {
    if (props.firstName) {
        const Title = `${props.firstName.charAt(0)}${props.lastName ? props.lastName.charAt(0) : ''}`
        return (
            <div className='avatar do-animate-rollover' onClick={props.handleClick}>
                {Title.toUpperCase()}
            </div>
        )
    }

    return ''
}

Avatar.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    handleClick: PropTypes.func
}

export default Avatar



// WEBPACK FOOTER //
// ./resources/js/components/Avatar.js